import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Translate from "@material-ui/icons/Translate";
import {
  Card,
  TextField,
  InputAdornment,
  Button,
  Typography,
  CardActionArea,
  CardMedia,
  CardContent,
  CardActions,
  DialogContent,
  CircularProgress,
  Snackbar,
  IconButton,
  Grid,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText
} from "@material-ui/core";
import { FetchData } from "../services/FetchData";
import ProgressLine from "./ProgressLine";
import { AppContext } from "../App";
import MyAppBar from "./MyAppBar";
import MyFooter from "./MyFooter";
import { validateEmail, isStorageSupported } from "../AppClass";
import InfoOutLined from "@material-ui/icons/InfoOutlined";
import { Redirect } from "react-router-dom";
import "./css/login-page.css";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/es";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { red } from "@material-ui/core/colors";
import createPalette from "@material-ui/core/styles/createPalette";
import image from "../images/image.png";

import { FireBaseUI } from "../AppClass";
import firebase from "firebase/app";
import { DesktopMac, Keyboard, KeyboardVoiceRounded } from "@material-ui/icons";

class LoginPage extends React.Component {
  state = {
    //email: "indraniltalukdarindia@gmail.com",
    email: "",
    submitting: false,
    token: "",
    token_submitting: false,
    token_visible: false,
    token_sent: false,

    openSnack: false,
    vertical: "top",
    horizontal: "center",
    snackMessage: "",

    redirect: false
  };

  onMailChange = event => {
    let mail = event.target.value;
    console.log(mail);
    this.setState({ email: mail });
  };

  onTokenChange = event => {
    let token = event.target.value;
    this.setState({ token: token });
  };

  handleSnackClose = () => {
    this.setState(state => ({
      openSnack: false
    }));
  };

  registerMail = () => {
    if (this.state.email.length < 4) {
      this.setState({
        openSnack: true,
        snackMessage: "Enter email address."
      });

      return false;
    }

    if (!validateEmail(this.state.email)) {
      this.setState({
        openSnack: true,
        snackMessage: "Enter valid email address."
      });
      return false;
    }

    if (!isStorageSupported()) {
      this.setState({
        openSnack: true,
        snackMessage:
          "This browser doesn't support local storage. Recommended to use updated Google Chrome or Mozilla Firefox."
      });
    }

    this.setState({ submitting: true });

    FetchData("/register", {
      email: this.state.email
    })
      .then(result => {
        //console.log(result);

        let jsonResult = JSON.parse(JSON.stringify(result));
        console.log(jsonResult);

        if (jsonResult.response === "mail_verified") {
          localStorage.setItem("user_status", "logged_in");
          localStorage.setItem("auth_token", jsonResult.auth_token);

          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            submitting: false,
            token_sent: true
          });
        }
      })
      .catch(error => {
        //alert(error);
        console.log(error);
        this.setState({ submitting: false });

        this.setState({
          openSnack: true,
          snackMessage: "Problem connecting internet."
        });
      });
  };

  authToken = () => {
    if (this.state.token_visible === false || this.state.token.length < 1) {
      this.setState({
        token_visible: true,
        openSnack: true,
        snackMessage: "Enter key to log in."
      });
      return false;
    }

    this.setState({ token_submitting: true });

    FetchData("/authtoken", {
      email: this.state.email,
      token: this.state.token
    })
      .then(result => {
        //console.log(result);
        this.setState({ token_submitting: false });

        let jsonResult = JSON.parse(JSON.stringify(result));
        console.log(jsonResult.auth);
        if (jsonResult.auth === "auth_success") {
          localStorage.setItem("user_status", "logged_in");
          localStorage.setItem("auth_token", jsonResult.auth_token);

          this.setState({
            redirect: true
          });
        } else if (jsonResult.auth === "token_expired") {
          this.setState({
            openSnack: true,
            snackMessage: "Key expired. Get a new key."
          });
        } else {
          this.setState({
            openSnack: true,
            snackMessage: "Key not correct."
          });
        }
      })
      .catch(error => {
        //alert(error);
        console.log(error);
        this.setState({ token_submitting: false });

        this.setState({
          openSnack: true,
          snackMessage: "Problem connecting internet."
        });
      });
  };

  componentWillMount() {
    console.log("LoginPage.js componentWillMount ", this.state.redirect);

    if (
      localStorage.getItem("user_status") !== null &&
      localStorage.getItem("user_status") === "logged_in"
    ) {
      this.setState({ redirect: true });
    }
  }

  componentDidMount() {
    let self = this;

    let FBUIConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          //alert(authResult.user.email + authResult.user.displayName);
          //console.log(authResult);

          if (authResult.user.email === null) {
            //console.log("Allow Akhor to access email.")
            // self.setState({
            //   openSnack: true,
            //   snackMessage: "Allow Akhor to access email."
            // });
            //return false
          }

          localStorage.setItem("user_status", "logged_in");
          localStorage.setItem("auth_token", authResult.user.uid);

          authResult.user.displayName === null
            ? localStorage.setItem("user_name", "")
            : localStorage.setItem("user_name", authResult.user.displayName);

          //window.location = "/home"

          self.setState({ redirect: true });

          return false;
        },
        uiShown: function() {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById("loader").style.display = "none";
        }
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      signInFlow: "popup",
      signInSuccessUrl: "http://localhost:3000",
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
        //firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        //firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        //firebase.auth.GithubAuthProvider.PROVIDER_ID,
        //firebase.auth.EmailAuthProvider.PROVIDER_ID,
        //firebase.auth.PhoneAuthProvider.PROVIDER_ID
      ],
      // Terms of service url.
      tosUrl: "http://localhost:3000/termsofservice",
      // Privacy policy url.
      privacyPolicyUrl: "http://localhost:3000/privacypolicy"
    };

    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        console.log(user);
      } else {
        // No user is signed in.
        FireBaseUI.start("#firebaseui-auth-container", FBUIConfig);
      }
    });
    //FireBaseUI.start("#firebaseui-auth-container", FBUIConfig);

    //bypass loginpage
    //localStorage.setItem("user_status", "logged_in");
    //localStorage.setItem("auth_token", "W5B6ZFJ2FyZFd48m4cfoDLAkhtG3");

    //Add to home screen
    // let deferredPrompt;

    // window.addEventListener("beforeinstallprompt", e => {
    //   // Prevent Chrome 67 and earlier from automatically showing the prompt
    //   e.preventDefault();
    //   // Stash the event so it can be triggered later.
    //   deferredPrompt = e;

    //   deferredPrompt.prompt();
    //   // Wait for the user to respond to the prompt
    //   deferredPrompt.userChoice.then(choiceResult => {
    //     if (choiceResult.outcome === "accepted") {
    //       console.log("User accepted the A2HS prompt");
    //     } else {
    //       console.log("User dismissed the A2HS prompt");
    //     }
    //     deferredPrompt = null;
    //   });

    // Update UI notify the user they can add to home screen
    //});

    // window.addEventListener('appinstalled', (evt) => {
    //   //app installed successfully
    // });
  }

  render() {
    const { vertical, horizontal } = this.state;
    const { classes } = this.props;

    //localStorage.setItem("user_status", "logged_in");

    if (
      this.state
        .redirect /*|| localStorage.getItem("user_status") === "logged_in"*/
    ) {
      return (
        <Redirect to={"/home"} />
        //<Route path={"/search"} component={MenuOptions}/>
      );
    }

    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <MuiThemeProvider theme={theme}>
            <div className={"App"}>
              <MyAppBar />
              <div className="login-box-hero">
                <div className="left-hero">
                  {/* <img
                                    className="wallpaperImage"
                                    src="https://www.invisionweb.in/site/static/media/asom_kotha_logo.a658c030.png"
                                /> */}
                  {/* <div>
                                    <p>
                                        <span className={"redUnderline"}>wrong</span> word
                                    </p>
                                </div> */}

                  <Typography gutterBottom variant="h3">
                    <span style={{ color: "#2196f3" }}>Volunteering page</span>
                    {/* <a
                      className={"link App-link"}
                      href="https://invisionweb.in"
                    >
                      Invision
                    </a> */}
                  </Typography>

                  <Typography
                    component="p"
                    variant="h5"
                    color="textSecondary"
                    gutterBottom
                  >
                    Assamese spell checker & Keyboard{" "}
                    <span style={{ color: "#2196f3" }}>AI</span>
                    <br /> 6,00,000+ words and adding...
                  </Typography>

                  {/* <List>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <KeyboardVoiceRounded />
                      </ListItemAvatar>
                      <ListItemText primary="Brunch this weekend?" />
                    </ListItem>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <KeyboardVoiceRounded />
                      </ListItemAvatar>
                      <ListItemText primary="Brunch this weekend?" />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <KeyboardVoiceRounded />
                      </ListItemAvatar>
                      <ListItemText primary="Summer BBQ" />
                    </ListItem>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <KeyboardVoiceRounded />
                      </ListItemAvatar>
                      <ListItemText primary="Oui Oui" />
                    </ListItem>
                  </List> */}

                  <div className="download hideClass">
                    <Button variant="outlined" color="primary">
                      <DesktopMac style={{ marginRight: "10px" }} />
                      Download Aakhor desktop
                    </Button>
                  </div>

                  <div className="dividerMargin">
                    <Divider />
                  </div>

                  <div className="firebase-parent">
                    <div id="loader" />
                    <div id="firebaseui-auth-container" />
                  </div>

                  <div className="email-btn-hero hideClass">
                    <TextField
                      id="email-signup"
                      name="email"
                      variant="outlined"
                      type="email"
                      fullWidth
                      defaultValue={this.state.email}
                      onChange={this.onMailChange}
                      placeholder={"Enter email"}
                      className={classes.padding}
                    />
                  </div>

                  {this.state.token_sent && (
                    <CardContent>
                      <Typography variant="overline">
                        One key will be sent to <b>{this.state.email}</b>'s
                        inbox or spam folder. Enter the key below to use আখৰ.
                        Haven't received key?
                        {this.state.submitting && (
                          <Button color="secondary" disabled>
                            Sending...
                          </Button>
                        )}
                        {!this.state.submitting && (
                          <Button color="secondary" onClick={this.registerMail}>
                            Resend
                          </Button>
                        )}
                      </Typography>
                    </CardContent>
                  )}

                  {(this.state.token_visible === true ||
                    this.state.token_sent) && (
                    <TextField
                      id="token-signup"
                      variant="outlined"
                      type="password"
                      fullWidth
                      defaultValue={this.state.token}
                      onChange={this.onTokenChange}
                      placeholder={"Enter key here"}
                      className={classes.padding}
                    />
                  )}

                  {this.state.token_submitting && <LinearProgress />}

                  <div className={"hideClass"}>
                    <Button
                      variant={this.state.token_sent ? "outlined" : "contained"}
                      color="primary"
                      onClick={this.registerMail}
                      className={classes.padding}
                      disabled={
                        this.state.token_submitting || this.state.submitting
                          ? true
                          : false
                      }
                    >
                      CONTINUE
                    </Button>

                    {!this.state.token_submitting && (
                      <Button
                        size="medium"
                        color="primary"
                        variant={
                          this.state.token_sent ? "contained" : "outlined"
                        }
                        onClick={this.authToken}
                        className={classes.loginWithKeyButton}
                      >
                        Login with key
                      </Button>
                    )}
                    {this.state.submitting === true && <LinearProgress />}
                  </div>
                </div>
                <div className="right-hero">
                  <div className="right-image-container">
                    {/* <div className="right-image" /> */}
                    <img src={image} className="right-image" />
                  </div>
                </div>
              </div>
              {/* <MyFooter /> */}

              <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={this.state.openSnack}
                onClose={this.handleSnackClose}
                ContentProps={{
                  "aria-describedby": "login-message-id"
                }}
                message={
                  <span id="login-message-id">{this.state.snackMessage}</span>
                }
              />
            </div>
          </MuiThemeProvider>
        )}
      </AppContext.Consumer>
    );
  }
}

const styles = theme => ({
  padding: {
    margin: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0"
    }
  },
  loginWithKeyButton: {
    margin: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      margin: "0 15px"
    }
  }
});

const theme = createMuiTheme({
  palette: createPalette({
    primary: {
      main: "#2196F3"
    },
    secondary: {
      main: "#8BC34A"
    },
    // accent: {
    //     ...green,
    //     A400: "#00e677"
    // },
    error: red,
    text: {
      // primary: "#5E5DA8",
      // secondary: "#E91E63"
      primary: "#212121",
      secondary: "#757575"
    }
    // alternateTextColor: Colors.red[200]
  }),
  overrides: {
    MuiLinearProgress: {
      root: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%"
      }
    }
  },
  typography: {
    useNextVariants: true
  }
});

export default withStyles(styles)(LoginPage);
